













import { Vue, Component } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";
import NoPage from "../../components/Error/NoPage.vue";
import { InstituteInfo } from "../../_models/instituteInfo";
import RequestsDataTable from "../../components/DataTables/RequestsDataTable.vue";
import CardTitle from "../../components/CardTitle.vue";
import * as temp from "../../_store/temp.module";

@Component({
	components: {
		NoPage,
		RequestsDataTable,
		CardTitle
	}
})
export default class GestioneTirFormativi extends Vue {
	private createParams: object;
	private dataTableParams: any;
	private titleParams: object;

	private listaRichiesteTirFormativi: any;

	constructor() {
		super();
		this.titleParams = {
			title: "RICHIESTE TIROCINI POST DIPLOMA",
			cols: "10",
			sm: "6",
			md: "6",
			lg: "5"
		};
		this.createParams = {
			visible: false,
			type: "",
			idIstituto: 0,
			idAnnoScolastico: 0,
			idAziendaIstitutoAnno: 0
		};
		this.dataTableParams = {
			headers: [
				{
					text: "Azienda Richiedente",
					value: "denominazioneAzienda"
				},
				{
					text: "Sede Attività",
					value: "comuneTirocinio"
				},
				{
					text: "Indirizzo Studio Richiesta",
					value: "nomeIndirizzoStudio"
				},
				{
					text: "Nome Tirocinante Indicato",
					value: "nomeTirocinante"
				},
				{
					text: "Cognome Tirocinante Indicato",
					value: "cognomeTirocinante"
				},
				{
					text: "Classe Tirocinante Indicato",
					value: "classeTirocinante"
				},
				{
					text: "Visualizza",
					value: "actionInstitute",
					sortable: false
				}
			],
			records: [],
			dialogParams: {
				title: "DETTAGLI TIROCINIO ESTIVO",
				type: "richiestaTirFormativoTab"
			},
			type: "tirocinioFormativo",
			filterType: "listaRichiesteAttivita"
		};
	}

	loadRichiesteTirFormativi(idAnnoScolastico: number) {
		// var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"])
		var instituteInfo = user.readInstituteInfo(this["$store"]);

		if(instituteInfo === null){
			return;
		}

		var payload = {
			idIstituto: instituteInfo.id,
			idAnnoScolastico: idAnnoScolastico
		};
		data
			.dispatchTirFormativiIstituto(this["$store"], payload)
			.then(result => {
				this.listaRichiesteTirFormativi = result;
				this.dataTableParams.records = result;
				bus.$emit("dataLoaded");
			})
			.catch(error => {
				if (error.response.status === 401) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	created() {
		var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
		var token = localStorage.getItem("userToken");
		var parsedToken: any;
		if (token !== null) {
			parsedToken = userUtils.parseToken(token);
		}
		var payload = {
			idUtente: parsedToken.IdUtente,
			tipoSoggetto: parsedToken.IdTipoSoggetto,
			username: parsedToken.Username
		};
		user
			.dispatchSetUserInfo(this["$store"], payload)
			.then(() => {
				user
					.dispatchSetInstituteInfo(this["$store"])
					.then(() => {
						this.loadRichiesteTirFormativi(idAnnoScolastico);
						bus.$emit("loadMenu");
					})
					.catch(() => {
						bus.$emit("stopLoading");
						auth.dispatchLogout(this["$store"]);
						user.dispatchClearState(this["$store"]);
						this["$router"].push("/sessionExpired");
					});
			})
			.catch(() => {
				bus.$emit("stopLoading");
				auth.dispatchLogout(this["$store"]);
				user.dispatchClearState(this["$store"]);
				this["$router"].push("/sessionExpired");
			});

		bus.$on("changeAnnoScolastico", (payload: any) => {
			this.loadRichiesteTirFormativi(payload);
		});
	}
}
